export default __webpack_public_path__ + "static/media/team1.123da42c.jpg";